import { useQuery } from '@tanstack/react-query'
import { useSpecificCategory } from '@zet/common/hooks/useSpecificCategory'

import useStore from '../../store'
import {
  getCustomerCount,
  getHomePageTopBrand,
  getLeadCount,
} from './functions'

export function useGetCustomerCount() {
  const { selectedDsaId } = useStore((state) => state)
  return useQuery(['getCustomerCount', selectedDsaId], getCustomerCount)
}

export function useGetHomePageTopBrand() {
  const { selectedDsaId } = useStore((state) => state)
  const { category } = useSpecificCategory()

  return useQuery(['getHomePageTopBrand', selectedDsaId], () =>
    getHomePageTopBrand({ categoryIds: category !== null ? [category] : [] })
  )
}

export function useGetLeadCount() {
  const { selectedDsaId } = useStore((state) => state)
  const { category } = useSpecificCategory()

  return useQuery(['getLeadCount', category, selectedDsaId], () =>
    getLeadCount({ categoryId: category || '' })
  )
}
